import PocketBase from 'pocketbase';

// Determine the PocketBase URL dynamically so it works over Tailscale/LAN
const getPbUrl = () => {
  if (process.env.NEXT_PUBLIC_POCKETBASE_URL) {
    return process.env.NEXT_PUBLIC_POCKETBASE_URL;
  }
  if (typeof window !== 'undefined') {
    // By using the same host and the /pb route, it routes through Next.js proxy
    return `${window.location.protocol}//${window.location.host}/pb`;
  }
  return 'http://127.0.0.1:8090';
};

// Global pocketbase instance
export const pb = new PocketBase(getPbUrl());

// Optional: Automatically load any auth state if stored in a cookie/localStorage
if (typeof window !== 'undefined') {
  pb.authStore.loadFromCookie(document.cookie);
  
  pb.authStore.onChange(() => {
    document.cookie = pb.authStore.exportToCookie({ httpOnly: false });
  });
}
